import { createGlobalStyle } from 'styled-components';
import 'normalize.css';
import { color, focusOutline, focusOutlineOffset, fallbackStack } from './tokens';

const Typography = createGlobalStyle`
  /* Ensuring elements are sized predictably */
  *, *::before, *::after {
    box-sizing: border-box;
  }

  /* Root sizing.
     Intentionally NOT stepping html{font-size} down at breakpoints —
     that pattern (previously 16→15→14 at md / mobileTypo) overrides
     users who've bumped their OS root size for accessibility. Fluid
     scaling is handled at the component level via clamp() in the
     fontSize tokens. */
  html {
    font-size: 16px;
    line-height: 1.4;
    font-family: 'Satoshi', ${fallbackStack};
    font-weight: 400;
  }

  /* Root sizing and background */
  html, body, #___gatsby, #gatsby-focus-wrapper {
    margin: 0;
    padding: 0;
    background: transparent;
  }

  body {
    min-height: 100vh;
  }
  @supports (height: 100svh) {
    body { min-height: 100svh; }
  }
  @supports (height: 100dvh) {
    body { min-height: 100dvh; }
  }

  /* Raw <a> elements inherit their parent's color by default.
     Styled-component wrappers that need a distinct link color should
     set it explicitly (see NavLink, CardDetailLink, SkipToContent). */
  a {
    text-decoration: none;
    color: currentColor;
  }

  /* Core defaults */
  h1, h2, h3, h4, h5, h6, p, ol, ul {
    margin: 0;
    padding: 0;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
  }

  input, button, textarea, select {
    font: inherit;
  }

  /* Consistent focus ring for all interactive elements.
     Uses a real outline + outline-offset (sourced from tokens.js) rather
     than a box-shadow halo so the space between element and ring is
     genuine transparent offset, not a painted white padding. Outline
     follows the element's own border-radius. !important is retained to
     beat MUI's own ring. */
  a:focus-visible,
  button:focus-visible,
  [role="button"]:focus-visible,
  [tabindex]:focus-visible,
  .MuiButtonBase-root:focus-visible {
    outline: ${focusOutline} !important;
    outline-offset: ${focusOutlineOffset};
    box-shadow: none !important;
  }

  /* Utility font classes */
  .garamond {
    font-family: 'ITC Garamond Std', ${fallbackStack};
  }

  .garamond-narrow-italic {
    font-family: 'ITC Garamond Std Light Narrow Italic', ${fallbackStack};
    font-style: italic;
  }

  .garamond-condensed-italic {
    font-family: 'ITC Garamond Std Light Condensed Italic', ${fallbackStack};
    font-style: italic;
  }

  .manrope {
    font-family: 'Manrope', ${fallbackStack};
  }
`;

export default Typography;